<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Hardware Letterbox';
                }
            },
            component_id: {
                default(){
                    return 'hardware_letterbox';
                }
            },
            hardwareColour: {
                required: true
            },
            slab: {
                required: true
            },
            hardwareHandle: {
                required: true
            },
            sidePanels: {
                required: true
            },
            frameId: {
                required: true
            },
            securedByDesign: {
                required: false,
                default() {
                    return 1;
                }
            },
            doorRange: {
                required: true
            },
            hardwareSuite: {
                required: false,
                default(){
                    return '';
                }
            },
            profile: {
                required: false,
                default() {
                    return 0;
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareColour, this.hardwareHandle, this.slab, this.sidePanels, this.frameId, this.securedByDesign, this.doorRange, this.profile);
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-letterbox?hardware_colour=' + this.hardwareColour
                        + '&hardware_handle=' + this.hardwareHandle
                        + '&slab=' + this.slab
                        + '&left=' + this.left_panel
                        + '&right=' + this.right_panel
                        + '&left_comp=' + this.left_composite_id
                        + '&right_comp=' + this.right_composite_id
                        + '&frame_id=' + this.frameId
                        + '&secured_by_design=' + this.securedByDesign
                        + '&door_range=' + this.doorRange
                        + '&suite=' + this.hardwareSuite
                        + '&profile=' + this.profile;
            },
            cache_key(){
                return '_' + this.hardwareSuite + '_' + this.hardwareColour + '_' + this.hardwareHandle + '_' + this.slab + '_' + this.left_panel + '_' + this.right_panel + '_' + this.left_composite_id + '_' + this.right_composite_id + '_' + this.frameId + '_' + this.securedByDesign + '_' + this.doorRange + '_' + this.profile;
            },
            left_panel(){
                if (this.sidePanels.left === null) {
                    return 1;
                }
                return this.sidePanels.left;
            },
            right_panel(){
                if (this.sidePanels.right === null) {
                    return 1;
                }
                return this.sidePanels.right;
            },
            left_composite_id(){
                if (this.sidePanels.left_composite_id === null) {
                    return 31;
                }
                return this.sidePanels.left_composite_id;
            },
            right_composite_id(){
                if (this.sidePanels.right_composite_id === null) {
                    return 31;
                }
                return this.sidePanels.right_composite_id;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
